import React, { useState } from 'react';

const Eighteenththeme = ({get_data}) => {
    const [cart, setCart] = useState([]);

    const addToCart = (item) => {
        setCart([...cart, item]);
        alert(`${item.service_name} added to cart!`);
    };

    return (
        <>
            <style>{`
        :root {
            /* Palette: Deep Ocean */
            --primary: #0f172a;       /* Navy */
            --secondary: #0ea5e9;     /* Sky */
            --bg: #f8fafc;
            --font-stack: 'Inter', sans-serif;
        }

        body { font-family: var(--font-stack); background: var(--bg); color: var(--primary); margin: 0; }
        .container { max-width: 1200px; margin: 0 auto; padding: 0 20px; }
        
        .navbar { display: flex; justify-content: space-between; align-items: center; padding: 20px 0; }
        .brand { font-size: 1.5rem; font-weight: 700; letter-spacing: -0.5px; }
        .nav a { margin-left: 20px; color: #64748b; text-decoration: none; font-weight: 500; }
        .nav a:hover { color: var(--primary); }
        
        .hero { background: var(--primary); color: white; padding: 100px 0; border-radius: 20px; margin-top: 20px; display: flex; align-items: center; }
        .hero h1 { font-size: 3rem; margin-bottom: 20px; }
        .btn { background: var(--secondary); color: white; padding: 12px 24px; border-radius: 8px; border: none; font-weight: 600; cursor: pointer; }
        
        .grid { display: grid; grid-template-columns: repeat(auto-fill, minmax(250px, 1fr)); gap: 40px; margin-top: 60px; }
        .card { background: white; border-radius: 12px; padding: 25px; box-shadow: 0 4px 6px -1px rgba(0,0,0,0.1); border: 1px solid #e2e8f0; }
        
        .section-title { font-size: 2rem; border-left: 5px solid var(--secondary); padding-left: 20px; margin: 80px 0 40px; }
        
        .footer { border-top: 1px solid #e2e8f0; margin-top: 100px; padding: 50px 0; color: #64748b; }
            `}</style>
            
            <link href="https://fonts.googleapis.com/css2?family=Inter:wght@400;600;700&display=swap" rel="stylesheet" />

            <div className="container">
                <nav className="navbar">
                    <div className="brand">{get_data.service_name}</div>
                    <div className="nav">
                        <a href="#">Home</a>
                        <a href="#services">Services</a>
                        <a href="#products">Products</a>
                    </div>
                </nav>
                
                <header className="hero">
                    <div style={{padding: '0 60px', width: '100%'}}>
                         <h1>Dive into Quality.</h1>
                         <p style={{fontSize: '1.2rem', color: '#cbd5e1', marginBottom: '30px', maxWidth: '500px'}}>Professional services tailored to your depth of needs.</p>
                         <button className="btn">Explore Services</button>
                    </div>
                </header>
                
                <h2 className="section-title" id="services">Our Services</h2>
                <div className="grid">
                    {get_data.categories && get_data.categories.map((item, index) => (
                        <div className="card" key={index}>
                             <div style={{width: '50px', height: '50px', background: '#e0f2fe', borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: '20px'}}>
                                 {item.icon ? <img src={item.icon.startsWith('http') ? item.icon : `https://reliep-images.s3.ap-south-1.amazonaws.com/public/storage/${item.icon}`} style={{width: '30px', height: '30px'}} alt=""/> : <span>🌊</span>}
                             </div>
                             <h3>{item.name}</h3>
                             <p style={{fontSize: '0.9rem', color: '#64748b', margin: '10px 0 20px'}}>{item.description}</p>
                             <a href={`tel:${get_data.mobile}`} style={{color: 'var(--secondary)', fontWeight: 600, textDecoration: 'none'}}>Contact Us &rarr;</a>
                        </div>
                    ))}
                </div>

                <h2 className="section-title" id="products">Products</h2>
                <div className="grid">
                    {get_data.product_services && get_data.product_services.map((item, index) => (
                        <div className="card" key={index} style={{padding: 0, overflow: 'hidden'}}>
                             <div style={{height: '200px'}}>
                                 <img src={item.featured_image && item.featured_image.startsWith('http') ? item.featured_image : `https://reliep-snaps.s3.ap-south-1.amazonaws.com/featured/${item.featured_image}`} style={{width: '100%', height: '100%', objectFit: 'cover'}} alt=""/>
                             </div>
                             <div style={{padding: '20px'}}>
                                 <h3>{item.service_name}</h3>
                                 <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: '15px'}}>
                                     {item.price && <span style={{fontWeight: 700}}>₹{item.price}</span>}
                                     <button onClick={() => addToCart(item)} className="btn" style={{padding: '8px 16px', fontSize: '0.8rem'}}>Add</button>
                                 </div>
                             </div>
                        </div>
                    ))}
                </div>
                
                <footer className="footer" id="contact">
                    <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '40px'}}>
                        <div>
                            <h3 style={{color: 'var(--primary)'}}>{get_data.service_name}</h3>
                            <p>{get_data.business_location_name}</p>
                            <p>{get_data.email}</p>
                        </div>
                        <div style={{textAlign: 'right'}}>
                            <p>&copy; {new Date().getFullYear()}. Built with precision.</p>
                        </div>
                    </div>
                </footer>
            </div>
        </>
    );
};

export default Eighteenththeme;
